import * as actionTypes from "./actionTypes";

const initialState = {
  error: null,
  loading: false,
  recallDetails: {
    columns: [],
    dataSource: [],
    totalRecalls: 0,
    pageSize: 20
  },
  filters: {
    search: ""
  },
  pagination: { pageSize: 20, currentPage: 1 }
};

const fetchRecallStart = (state) => ({
  ...state,
  loading: true
});

const fetchRecallSuccess = (state, action) => ({
  ...state,
  recallDetails: action.data,
  error: null,
  loading: false
});

const fetchRecallFail = (state, action) => ({
  ...state,
  error: action.error,
  loading: false
});

const downloadVinStart = (state) => ({ ...state, error: null, loading: true });

const downloadVinSuccess = (state) => ({
  ...state,
  loading: false
});

const downloadVinFail = (state, action) => ({
  ...state,
  error: action.error,
  loading: false
});

const setPageSize = (state, action) => {
  const {
    recallDetails: { totalRecalls },
    pagination: { currentPage }
  } = state;
  const lastPage = totalRecalls / action.data;

  return {
    ...state,
    pagination: {
      ...state.pagination,
      pageSize: action.data,
      currentPage: lastPage > currentPage ? currentPage : Math.ceil(lastPage)
    }
  };
};

const setCurrentPage = (state, action) => ({
  ...state,
  pagination: {
    ...state.pagination,
    currentPage: action.data
  }
});
const setSearchInput = (state, action) => ({
  ...state,
  filters: {
    ...state.filters,
    search: action.data
  }
});

export const recallReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RECALL_START:
      return fetchRecallStart(state, action);

    case actionTypes.FETCH_RECALL_SUCCESS:
      return fetchRecallSuccess(state, action);

    case actionTypes.FETCH_RECALL_FAIL:
      return fetchRecallFail(state, action);

    case actionTypes.DOWNLOAD_VIN_START:
      return downloadVinStart(state, action);

    case actionTypes.DOWNLOAD_VIN_SUCCESS:
      return downloadVinSuccess(state, action);

    case actionTypes.DOWNLOAD_VIN_FAIL:
      return downloadVinFail(state, action);

    case actionTypes.SET_PAGE_SIZE:
      return setPageSize(state, action);

    case actionTypes.SET_SEARCH_INPUT:
      return setSearchInput(state, action);

    case actionTypes.SET_CURRENT_PAGE:
      return setCurrentPage(state, action);

    default:
      return state;
  }
};
